import n from "./ghl-ui.es1582.js";
var s = {
  // Year
  y: function(e, t) {
    var r = e.getUTCFullYear(), u = r > 0 ? r : 1 - r;
    return n(t === "yy" ? u % 100 : u, t.length);
  },
  // Month
  M: function(e, t) {
    var r = e.getUTCMonth();
    return t === "M" ? String(r + 1) : n(r + 1, 2);
  },
  // Day of the month
  d: function(e, t) {
    return n(e.getUTCDate(), t.length);
  },
  // AM or PM
  a: function(e, t) {
    var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(e, t) {
    return n(e.getUTCHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H: function(e, t) {
    return n(e.getUTCHours(), t.length);
  },
  // Minute
  m: function(e, t) {
    return n(e.getUTCMinutes(), t.length);
  },
  // Second
  s: function(e, t) {
    return n(e.getUTCSeconds(), t.length);
  },
  // Fraction of second
  S: function(e, t) {
    var r = t.length, u = e.getUTCMilliseconds(), o = Math.floor(u * Math.pow(10, r - 3));
    return n(o, t.length);
  }
};
const c = s;
export {
  c as default
};
